<template lang="pug">
aside.follow-modal
  .follow-modal__close(@click='closeModal')
  .follow-modal__container.follow-modal__container--no-pb
    h5.follow-modal__title フォローありがとうございました！
    p.follow-modal__message これらの企業をフォローしてみませんか？
    ul.follow-modal-list
      li.follow-modal-list__item(v-for='(item, index) in dataList')
        a.follow-modal-list__name(:href="`/main/html/searchrlp/company_id/${item.company_id}`") {{item.company_name}}
        .follow-modal-list__button
          .button--follow-wrap
            button.button--follow(@click.prevent="followCompany(item.company_id, index)") フォロー
    .follow-modal__bottom-fade
</template>
<script>
import { postFollowing } from './../../user/postFollowUnfollow';

export default {
  name: 'FollowPopularCompany',
  props: {
    dataListProps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dataList: {
      get () {
        return this.dataListProps;
      },
      set (newValue) {
        this.$emit('update:dataListProps', newValue);
      }
    }
  },
  methods: {
    followCompany: function (companyId, index) {
      postFollowing(companyId)
        .then(res => {
          if (res.status) {
            this.$emit('spliceDataList', index);
          }
        })
        .catch(err => {
          throw err;
        });
    },
    closeModal: function () {
      this.$emit('closeModal');
    }
  }
};
</script>
